import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["PoolsContent"] */ "/app/src/app/[locale]/(main)/(home)/_components/Pools/PoolsContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoPlayer"] */ "/app/src/app/[locale]/(main)/(home)/_components/Pools/VideoPlayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["V2AnnouncementStrip"] */ "/app/src/app/[locale]/(main)/(home)/_components/TopSection/V2AnnouncementStrip.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/community/facebook.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/community/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/community/youTubeShorts.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/loaderButton.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/pools.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shared/Community/CommunityItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KYCAlertBanner"] */ "/app/src/components/shared/KYCAlertBanner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LockedAccountBanner"] */ "/app/src/components/shared/LockedAccountBanner/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/accordion.tsx");
